/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";

// Images
import let1 from "assets/images/Services/LetOnly/let1.jpg";
import let2 from "assets/images/Services/LetOnly/let2.jpg";
import let3 from "assets/images/Services/LetOnly/let3.jpg";
import let4 from "assets/images/Services/LetOnly/let4.jpg";
import let5 from "assets/images/Services/LetOnly/let5.jpg";
import let6 from "assets/images/Services/LetOnly/let6.jpg";
import let7 from "assets/images/Services/LetOnly/let7.jpg";
import let8 from "assets/images/Services/LetOnly/let8.jpg";

function LetOnly_Section1() {
  return (
    <Container>
      <SubTitleContents
        title="Why Choose Our 'Let Only' Property Management?"
        contents="Our “Let Only” Property Service is perfect for landlords who prefer a hands-on approach but need assistance finding and securing reliable tenants. We take care of the initial setup, ensuring your property is occupied quickly and efficiently."
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={let1} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={let5} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={let8} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default LetOnly_Section1;
